// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DMs4","newExpiryDate":"styles_newExpiryDate__2BgZC","footer":"styles_footer__1ndon"};